<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>คำสั่งซื้อย้อนหลัง ประจำปี {{ new Date().getFullYear() + 543 }}</h2>
        </div>
        <v-card>
            <div class="pa-3">
                <div class="d-flex align-center mb-3">
                    <div>ยอดขายประจำเดือน</div>
                    <div class="ml-2">
                        <v-select item-text="name" item-value="id" v-model="month" :items="$store.state.monthList" @change="chartAll" color="primary" hide-details="auto" outlined>
                        </v-select>
                    </div>
                </div>

                <div class="grid_count_list_content_report_list mb-3">
                    <v-card class="mr-1 pa-3">
                        <v-card class="d-flex align-center icon_list_content_report_list" color="primary">
                            <v-icon size="40">mdi-cash-multiple</v-icon>
                        </v-card>
                        <div class="text-right">
                            <div>บาท</div>
                            <h3>{{ sale_income }}</h3>
                        </div>
                        <hr>
                        <div>ยอดขายรวม</div>
                    </v-card>
                    <v-card class="ml-1 pa-3">
                        <v-card class="d-flex align-center icon_list_content_report_list" color="primary">
                            <v-icon size="40">mdi-account-group</v-icon>
                        </v-card>
                        <div class="text-right">
                            <div>คน</div>
                            <h3>{{ count_view }}</h3>
                        </div>
                        <hr>
                        <div>ยอดผู้เข้าชมเว็บไซต์</div>
                    </v-card>
                </div>

                <div>
                    <div>
                        <canvas id="my-chart"></canvas>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</div>
</template>

<script>
import Chart from 'chart.js'
// import 'chartjs-plugin-labels'
import contentreport from '@/api/content/contentpurchase/contentreport.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            month: new Date().getMonth() + 1,
            sale_income: 0,
            count_view: 0,
            data: [],
        }
    },
    methods: {
        async chartAll() {
            this.loading_page = true
            await contentreport.reportList(this.month).then((response) => {
                if (response.data.successful === true) {
                    this.sale_income = response.data.saleIncom
                    this.count_view = response.data.count_view
                    this.data = response.data.dateList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            let max_sale_total = Math.max(...this.data.map((detail) => {
                return detail.saleTotal
            }))
            let max_view_total = Math.max(...this.data.map((detail) => {
                return detail.viewTotal
            }))
            let max_total = Math.max(max_sale_total,max_view_total)
            let ctx = document.getElementById('my-chart')
            await new Chart(ctx, {
                type: 'line',
                data: {
                    labels: this.data.map((detail) => {
                        return detail.date
                    }),
                    datasets: [{
                            label: 'ยอดขาย',
                            data: this.data.map((detail) => {
                                return detail.saleTotal
                            }),
                            borderColor: 'rgb(76, 175, 80)',
                            fill: false,
                            tension: 0.1
                        },
                        {
                            label: 'ผู้เข้าชม',
                            data: this.data.map((detail) => {
                                return detail.viewTotal
                            }),
                            borderColor: 'rgb(75, 192, 192)',
                            fill: false,
                            tension: 0.1
                        },

                    ]
                },
                options: {
                    legend: {
                        align: 'center',
                        position: 'bottom'
                    },
                    responsive: true,
                    maintainAspectRatio: true,
                    plugins: {
                        labels: {
                            render: 'value',
                            fontColor: ['#000000', '#000000'],
                            precision: 2
                        }
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                max: max_total + 100,
                                beginAtZero: true
                            },
                        }],

                    },
                }
            })
        }
    },
    mounted() {
        this.chartAll()
    }
}
</script>

<style scoped>
.grid_count_list_content_report_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.icon_list_content_report_list {
    padding: 15px;
    border-radius: 4px !important;
    position: absolute !important;
    top: -22px;
    left: 10px;
}

.icon_list_content_report_list>i {
    color: #fff !important;
}
</style>
